// src/components/ui/Section.tsx — section heading with eyebrow subtitle.
import type { CSSProperties, ReactNode } from "react";
import { C, F } from "../../theme";
import { Eyebrow } from "./Eyebrow";

export interface SectionProps {
  title: ReactNode;
  sub?: ReactNode;
  right?: ReactNode;
  style?: CSSProperties;
}

export const Section = ({ title, sub, right, style }: SectionProps) => (
  <div
    style={{
      display: "flex",
      alignItems: "flex-end",
      justifyContent: "space-between",
      gap: 12,
      marginBottom: 14,
      ...style,
    }}
  >
    <div style={{ flex: 1, minWidth: 0 }}>
      {sub && <Eyebrow style={{ marginBottom: 2 }}>{sub}</Eyebrow>}
      <h2
        style={{
          fontFamily: F.serif,
          fontSize: 24,
          fontWeight: 700,
          color: C.ink,
          margin: 0,
          lineHeight: 1.1,
          letterSpacing: -0.3,
        }}
      >
        {title}
      </h2>
    </div>
    {right}
  </div>
);
